export const MODALS_KEYS = {
  paymentFailed: 'paymentFailed',
};
